import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { IconButton } from '../../buttons';
export type CategoryCardProps = {
  title?: string;
  imageUrl?: string;
  href?: string;
};

export const CategoryCard = ({ title, imageUrl, href }: CategoryCardProps) => {
  return (
    <a href={href} className="group">
      <article className="bg-neutral-40 aspect-square p-5 flex justify-between flex-col">
        <div className="flex justify-between">
          <div className="h-10">
            {imageUrl && (
              <img src={imageUrl} width="" className="h-10 w-10" alt={title} />
            )}
          </div>
          <IconButton
            rounded
            className="h-10 w-10"
            variant="ghost"
            title={`Gå til kategorien ${title}`}
          >
            <ArrowRightIcon className="h-4" />
          </IconButton>
        </div>

        <h2 className="group-hover:underline">{title}</h2>
      </article>
    </a>
  );
};

export default CategoryCard;
